export const FETCH_DELIVERYS_REQUESTED = 'FETCH_DELIVERYS_REQUESTED';
export const FETCH_DELIVERYS_SUCCEEDED = 'FETCH_DELIVERYS_SUCCEEDED';
export const SORT_DELIVERYS_REQUESTED = 'SORT_DELIVERYS_REQUESTED';
export const SORT_DELIVERYS_SUCCEEDED = 'SORT_DELIVERYS_SUCCEEDED';
export const UPDATE_DELIVERY_FILTER = 'UPDATE_DELIVERY_FILTER';
export const SELECT_ALL_VISIBLE_DELIVERY = 'SELECT_ALL_VISIBLE_DELIVERY';
export const DELIVER_PRODUCT_REQUESTED = 'DELIVER_PRODUCT_REQUESTED';
export const DELIVER_PRODUCT_SUCCEEDED = 'DELIVER_PRODUCT_SUCCEEDED';
export const DELIVER_PRODUCT_FAILED = 'DELIVER_PRODUCT_FAILED';
export const REINDEX_SELECTED_ITEM = 'REINDEX_SELECTED_ITEM';
export const REMIND_DRIVER_ON_HIS_WAY_REQUESTED = 'REMIND_DRIVER_ON_HIS_WAY_REQUESTED';
export const REMIND_DRIVER_ON_HIS_WAY_SUCCEEDED = 'REMIND_DRIVER_ON_HIS_WAY_SUCCEEDED';
export const SELECT_ALL_DELIVERY = 'SELECT_ALL_DELIVERY';
export const RESET_DELIVERY_SELECTION = 'RESET_DELIVERY_SELECTION';
